import { render, staticRenderFns } from "./UserAvatars.vue?vue&type=template&id=291c5cde&scoped=true"
import script from "./UserAvatars.vue?vue&type=script&lang=js"
export * from "./UserAvatars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291c5cde",
  null
  
)

export default component.exports